module.exports = __webpack_public_path__ + "img/brand-pa.de946ebc.svg";